import { Checkbox } from "@komplett/design-system";
import React, { useState } from "react";

import { setPopupEnabled } from "../../slices/actions";
import { useDispatch, useSelector } from "../../utils/hooks";
import strings from "../../utils/strings";

export const Configuration = () => {
	const dispatch = useDispatch();
	const isPopupEnabled = useSelector(
		(state) => state.popup.configuration.isPopupEnabled,
	);

	const [isChecked, toggleIsChecked] = useState(isPopupEnabled);

	return (
		<section className="addtocart-popup__configuration">
			<Checkbox
				id="enablePopupCheckbox"
				size="sm"
				checked={isChecked}
				label={strings.enableaddtocartpopup}
				onChange={({ target: { checked } }) => {
					toggleIsChecked(!isChecked);
					dispatch(setPopupEnabled(checked));
				}}
			/>
		</section>
	);
};
